export interface Child {
    displayName : String;
    localChildId : String;
    globalChildId : String;
    dateOfBirth : Date;
    gender : Gender;
}

export enum Gender {
    UNKNOWN = "UNKNOWN",
    MALE = "MALE",
    FEMALE = "FEMALE"
}